<div class="flex flex-col h-full">
    <div class="space-y-4 flex-1 overflow-y-auto">

        <div class="flex-col justify-center px-20">
              @if(loggedIn()) {
                <div class="grid grid-cols-1 gap-4 items-stretch">
                    <itsme-customer-summary class="h-full"></itsme-customer-summary>
                </div>

                <!-- TODO : a reactiver si necessaire -->
                <!-- <button 
                    class="my-5 px-5 py-2 text-sm rounded-md bg-red-600 dark:bg-red-500 text-white disabled:opacity-40 hover:bg-secondary-500 transition"
                    (click)="fakeLogout()">Logout (for debug)
                </button> -->
            }
            @else{

            <!-- <div class="flex justify-center">
                <img [src]="'images/products/itsme.svg'" alt="itsme" class="w-15 h-15" />
            </div>
            <div class="flex justify-center my-5">
                <p>{{ 'i18n.app.features.pages.order.wizard.step_03.identification.label_01' | translate }}</p>
            </div> -->
            <div class="mb-1 grid grid-cols-2 items-center">
                <div class="col-span-2">
                    <h4>{{ 'i18n.app.features.pages.order.wizard.step_03.identification.label_02' | translate }}</h4>
                </div>

                <div
                    class="w-sm flex-col justify-center gap-4 bg-slate-50/50 p-10 rounded-xl border border-slate-100 dark:bg-white/[0.05] dark:border-slate-300/[0.1]">
                    <h5>{{ 'i18n.app.features.pages.order.wizard.step_03.identification.label_03' | translate }}</h5>
                    <p>{{ 'i18n.app.features.pages.order.wizard.step_03.identification.label_04' | translate }}</p>
                    <itsme-login-button></itsme-login-button>
                </div>
                
                <div class="flex justify-center">
                    <a href="https://www.itsme-id.com/get-started/eid" target="_blank" class="w-sm cursor-pointer flex flex-row  gap-4 bg-gray-100/[0.2] hover:shadow-md p-4 
                        dark:shadow-orange-900 shadow-orange-100 rounded-xl border border-slate-100 
                        dark:bg-white/[0.1] dark:border-slate-300/[0.1]">
                        <img [src]="'images/products/itsme.svg'" alt="itsme" class="w-12 h-12" />
                        <div>
                            <h5>{{ 'i18n.app.features.pages.order.wizard.step_03.identification.label_05' | translate }}</h5>
                            <p>{{ 'i18n.app.features.pages.order.wizard.step_03.identification.label_06' | translate }}</p>
                        </div>
                    </a>
                </div>
            </div>
        }
        </div>
    </div>

